(function() {
    "use strict";

    angular
        .module("app")
        .component("forgotPassword",
            { // forgot-password
                templateUrl: "src/app/forgotPassword/forgotPassword.html",
                controller: controller,
                bindings: {
                    ui: "<",
                    onReturnToLogin: "&",
                    onContinue: "&"
                }
            });

    function controller(EMAIL_FORMAT) {
        const $ctrl = this;
        $ctrl.emailFormat = EMAIL_FORMAT;

        $ctrl.formData = {
            email: ""
        };
    }

    controller.$inject = ["EMAIL_FORMAT"];

})();